import { object, string } from '@gogame/schemas';

export const screenSchema = object({
  partner: string().default('facebook'),
}).default({
  partner: 'facebook',
});
